(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    var v = (parseInt(cents, 10) || 0) / 100;
    return v.toFixed(2);
  }

  var state = { slideIndex: 0 };
  var productData = null;

  /* ---------------- Accordions (specs + FAQ) ---------------- */
  qsa('[data-vp-accordion-group]').forEach(function (group) {
    qsa('[data-vp-accordion-toggle]', group).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var icon = qs('[data-vp-accordion-icon]', btn);
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        qsa('[data-vp-accordion-toggle]', group).forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            other.nextElementSibling.style.gridTemplateRows = '0fr';
            var otherIcon = qs('[data-vp-accordion-icon]', other);
            if (otherIcon) otherIcon.style.transform = 'none';
          }
        });

        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.style.gridTemplateRows = isOpen ? '0fr' : '1fr';
        if (icon) icon.style.transform = isOpen ? 'none' : 'rotate(135deg)';
      });
    });
  });

  /* ---------------- Announcement marquee: pause on hover/touch ---------------- */
  qsa('[data-vp-marquee-wrap]').forEach(function (wrap) {
    var track = qs('[data-vp-marquee-track]', wrap);
    if (!track) return;
    wrap.addEventListener('pointerenter', function () { track.style.animationPlayState = 'paused'; });
    wrap.addEventListener('pointerleave', function () { track.style.animationPlayState = 'running'; });
  });

  /* ---------------- Horizontal scroll containers: mouse drag + wheel support ---------------- */
  qsa('[data-hs]').forEach(function (el) {
    var dragging = false, moved = false, startX = 0, startScroll = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest('button, a, input, select, textarea')) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.setPointerCapture(e.pointerId);
      el.classList.add('vp-hs-dragging');
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function stopDrag() {
      dragging = false;
      el.classList.remove('vp-hs-dragging');
    }
    el.addEventListener('pointerup', stopDrag);
    el.addEventListener('pointercancel', stopDrag);

    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  });

  /* ---------------- Auto-scrolling drag carousels (e.g. UGC photo strip) ---------------- */
  qsa('[data-vp-autoscroll]').forEach(function (wrap) {
    var track = qs('[data-vp-autoscroll-track]', wrap);
    if (!track) return;
    var loopSeconds = parseFloat(wrap.getAttribute('data-vp-autoscroll')) || 26;

    var offset = 0;
    var setWidth = 0;
    var dragging = false, moved = false, dragStartX = 0, dragStartOffset = 0;

    function measure() { setWidth = track.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);

    function apply() {
      if (setWidth > 0) offset = ((offset % setWidth) + setWidth) % setWidth;
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }

    wrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest('a, button, input, select, textarea')) return;
      dragging = true;
      moved = false;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      wrap.setPointerCapture(e.pointerId);
      wrap.classList.add('vp-hs-dragging');
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) moved = true;
      offset = dragStartOffset - dx;
      apply();
    });
    function stopDrag() {
      dragging = false;
      wrap.classList.remove('vp-hs-dragging');
    }
    wrap.addEventListener('pointerup', stopDrag);
    wrap.addEventListener('pointercancel', stopDrag);
    wrap.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    var last = null;
    function tick(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000;
      last = ts;
      if (!dragging && setWidth > 0) {
        offset += (setWidth / loopSeconds) * dt;
        apply();
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });

  /* ---------------- Reviews: arrow-controlled scroll ---------------- */
  var reviewsScroll = qs('[data-vp-reviews-scroll]');
  if (reviewsScroll) {
    function reviewsScrollBy(dir) {
      var card = reviewsScroll.querySelector('[data-vp-review-card]');
      var gap = parseFloat(getComputedStyle(reviewsScroll).columnGap || getComputedStyle(reviewsScroll).gap) || 20;
      var step = card ? card.getBoundingClientRect().width + gap : 300;
      reviewsScroll.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    var reviewsPrev = qs('[data-vp-reviews-prev]');
    var reviewsNext = qs('[data-vp-reviews-next]');
    if (reviewsPrev) reviewsPrev.addEventListener('click', function () { reviewsScrollBy(-1); });
    if (reviewsNext) reviewsNext.addEventListener('click', function () { reviewsScrollBy(1); });
  }

  /* ---------------- Mobile nav drawer ---------------- */
  var navDrawer = qs('[data-vp-nav-drawer]');
  var scrim = qs('[data-vp-scrim]');

  function setScrim(active) {
    if (!scrim) return;
    scrim.style.opacity = active ? '1' : '0';
    scrim.style.pointerEvents = active ? 'auto' : 'none';
  }

  function openNav() {
    if (!navDrawer) return;
    navDrawer.style.transform = 'translateX(0)';
    setScrim(true);
  }
  function closeNav() {
    if (!navDrawer) return;
    navDrawer.style.transform = 'translateX(-104%)';
    if (!isCartOpen()) setScrim(false);
  }
  qsa('[data-vp-open-nav]').forEach(function (b) { b.addEventListener('click', openNav); });
  qsa('[data-vp-close-nav]').forEach(function (b) { b.addEventListener('click', closeNav); });

  /* ---------------- Cart drawer ---------------- */
  function isCartOpen() {
    var d = qs('[data-vp-cart-drawer]');
    return d && d.style.transform === 'translateX(0px)';
  }
  function openCart() {
    var d = qs('[data-vp-cart-drawer]');
    if (!d) return;
    d.style.transform = 'translateX(0)';
    setScrim(true);
  }
  function closeCart() {
    var d = qs('[data-vp-cart-drawer]');
    if (!d) return;
    d.style.transform = 'translateX(104%)';
    if (navDrawer && navDrawer.style.transform !== 'translateX(0px)') setScrim(false);
  }
  function bindCartControls() {
    qsa('[data-vp-open-cart]').forEach(function (b) {
      b.removeEventListener('click', openCart);
      b.addEventListener('click', openCart);
    });
    qsa('[data-vp-close-cart]').forEach(function (b) {
      b.removeEventListener('click', closeCart);
      b.addEventListener('click', closeCart);
    });
    qsa('[data-vp-qty-inc]').forEach(function (b) { b.addEventListener('click', function () { changeLineQty(b, 1); }); });
    qsa('[data-vp-qty-dec]').forEach(function (b) { b.addEventListener('click', function () { changeLineQty(b, -1); }); });
    qsa('[data-vp-line-remove]').forEach(function (b) { b.addEventListener('click', function () { removeLine(b); }); });
  }
  bindCartControls();

  if (scrim) {
    scrim.addEventListener('click', function () { closeCart(); closeNav(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeNav(); }
  });

  /* Refresh the cart-drawer section HTML in place after any cart mutation */
  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshWrap = doc.querySelector('#shopify-section-cart-drawer');
        var currentWrap = document.querySelector('#shopify-section-cart-drawer');
        if (freshWrap && currentWrap) {
          var wasOpen = isCartOpen();
          currentWrap.innerHTML = freshWrap.innerHTML;
          bindCartControls();
          scrim = qs('[data-vp-scrim]');
          if (scrim) scrim.addEventListener('click', function () { closeCart(); closeNav(); });
          if (wasOpen) openCart();
        }
        updateHeaderCartCount();
      });
  }

  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-vp-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  function changeLineQty(btn, delta) {
    var line = btn.closest('[data-vp-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtyEl = qs('[data-vp-qty-value]', line);
    var current = parseInt(qtyEl.textContent, 10) || 1;
    var next = Math.max(0, current + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    })
      .then(function () { return refreshCartDrawer(); });
  }

  function removeLine(btn) {
    var line = btn.closest('[data-vp-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () { return refreshCartDrawer(); });
  }

  /* ---------------- Add to cart (product form) ---------------- */
  var productForm = qs('[data-vp-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = productForm.querySelector('button[type="submit"]');
      var label = submitBtn ? submitBtn.querySelector('[data-vp-add-label]') : null;
      var originalHtml = label ? label.innerHTML : null;
      if (label) label.textContent = 'Adding...';
      if (submitBtn) submitBtn.disabled = true;

      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          return refreshCartDrawer();
        })
        .then(function () {
          openCart();
        })
        .catch(function () {
          window.alert('Something went wrong adding this to your cart. Please try again.');
        })
        .finally(function () {
          if (label && originalHtml) label.innerHTML = originalHtml;
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* ---------------- Buy now / more payment options (skip cart, straight to checkout) ---------------- */
  function addToCartThenCheckout(triggerEl, labelSelector, redirectingText) {
    if (!triggerEl || !productForm) return;
    triggerEl.addEventListener('click', function (e) {
      e.preventDefault();
      var label = qs(labelSelector, triggerEl);
      var originalHtml = label ? label.innerHTML : null;
      if (label) label.textContent = redirectingText;
      triggerEl.setAttribute('aria-disabled', 'true');

      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.alert('Something went wrong. Please try again.');
          if (label && originalHtml) label.innerHTML = originalHtml;
          triggerEl.removeAttribute('aria-disabled');
        });
    });
  }

  addToCartThenCheckout(qs('[data-vp-buy-now]'), '[data-vp-buy-now-label]', 'Redirecting...');
  addToCartThenCheckout(qs('[data-vp-more-payment]'), '[data-vp-more-payment-label]', 'Redirecting...');

  /* ---------------- Sticky mobile add-to-cart bar ---------------- */
  var mobileBar = qs('[data-vp-mobile-bar]');
  var heroSection = qs('[data-vp-hero-section]');
  function updateMobileBar(variant) {
    if (!mobileBar) return;
    var priceEl = qs('[data-vp-mobile-price]', mobileBar);
    var labelEl = qs('[data-vp-mobile-label]', mobileBar);
    if (variant && priceEl) priceEl.textContent = '$' + variant.priceFormatted;
    if (variant && labelEl && productData) labelEl.textContent = productData.title || '';
  }
  var mobileAddBtn = qs('[data-vp-mobile-add]');
  if (mobileAddBtn && productForm) {
    mobileAddBtn.addEventListener('click', function () {
      productForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  function isNarrowViewport() { return window.innerWidth < 1000; }
  var pastHero = false;
  function updateStickyBarVisibility() {
    if (!mobileBar) return;
    var show = isNarrowViewport() && pastHero && !isCartOpen();
    mobileBar.style.display = show ? 'flex' : 'none';
    var footerBarSpace = qs('[data-vp-bar-space]');
    if (footerBarSpace) footerBarSpace.style.height = (isNarrowViewport() && pastHero) ? '86px' : '0px';
  }
  window.addEventListener('resize', updateStickyBarVisibility);
  window.addEventListener('scroll', function () {
    if (heroSection) {
      var rect = heroSection.getBoundingClientRect();
      pastHero = rect.bottom < 40;
    }
    updateStickyBarVisibility();
  }, { passive: true });

  /* ---------------- Gallery / variant sync ---------------- */
  function loadProductData() {
    var script = qs('[data-vp-product]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function initGallery() {
    productData = loadProductData();
    var track = qs('[data-vp-track]');
    var thumbs = qsa('[data-vp-thumb]');
    var dots = qsa('[data-vp-dot]');
    var priceEl = qs('[data-vp-price-value]');
    var compareWrapEl = qs('[data-vp-compare]');
    var compareEl = qs('[data-vp-compare-value]');
    var savePctEl = qs('[data-vp-save-pct]');
    var stockEl = qs('[data-vp-stock]');
    var variantLabelEl = qs('[data-vp-variant-label]');
    var addTotalEl = qs('[data-vp-add-total]');
    var variantIdInput = qs('[data-vp-variant-id]');

    if (!track || !productData || !productData.variants || !productData.variants.length) return;

    var prevBtn = qs('[data-vp-prev]');
    var nextBtn = qs('[data-vp-next]');

    function updateDots(i) {
      dots.forEach(function (d, idx) { d.style.opacity = idx === i ? '1' : '.28'; });
    }
    function updateThumbs(i) {
      thumbs.forEach(function (t, idx) {
        var ring = qs('[data-vp-thumb-ring]', t);
        if (ring) ring.style.display = idx === i ? '' : 'none';
      });
    }
    function updateVariant(i) {
      var v = productData.variants[i];
      if (!v) return;
      if (variantIdInput) variantIdInput.value = v.id;
      if (priceEl) priceEl.textContent = v.priceFormatted;
      if (addTotalEl) addTotalEl.textContent = v.priceFormatted;

      var hasCompare = v.compareAtPrice && parseFloat(v.compareAtPrice) > parseFloat(v.price);
      if (compareWrapEl) {
        compareWrapEl.style.display = hasCompare ? '' : 'none';
      }
      if (compareEl) {
        compareEl.textContent = v.compareAtPriceFormatted;
      }
      if (savePctEl) {
        if (hasCompare) {
          var pct = Math.round((1 - parseFloat(v.price) / parseFloat(v.compareAtPrice)) * 100);
          savePctEl.style.display = '';
          savePctEl.textContent = 'Save ' + pct + '%';
        } else {
          savePctEl.style.display = 'none';
        }
      }
      if (stockEl) {
        if (v.available === false) {
          stockEl.innerHTML = '<strong style="color:#191712;font-weight:700;">Sold out</strong>';
        } else {
          stockEl.innerHTML = '<strong style="color:#191712;font-weight:700;">Low stock</strong> (9 items), ready to be shipped';
        }
      }
      if (variantLabelEl) variantLabelEl.textContent = v.title;
      updateMobileBar(v);
    }

    function goTo(i, instant) {
      var n = productData.variants.length;
      i = ((i % n) + n) % n;
      state.slideIndex = i;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      updateDots(i);
      updateThumbs(i);
      updateVariant(i);
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { goTo(idx); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(state.slideIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(state.slideIndex + 1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== state.slideIndex && i >= 0 && i < productData.variants.length) {
          state.slideIndex = i;
          updateDots(i);
          updateThumbs(i);
          updateVariant(i);
        }
      }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(state.slideIndex, true); });

    updateVariant(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

  updateStickyBarVisibility();
})();
